<template>
  <tr v-if="requirement.editing" class="requirement row qualification-commencement editing" key="editing">
    <can I="edit" a="Opportunity">
      <th v-if="first" class="text-xs-right">Qualification</th>
      <td v-else class="text-xs-right">
        {{ requirement.mandatory ? 'and' : 'or'}}
      </td>
      <td colspan="2">
        <v-toolbar flat class="transparent">
          <v-select
            v-model="requirement.mandatory"
            :items="[{ text: 'must', value: true }, { text: 'could', value: false }]"
          />
          <label class="body px-2">be&nbsp;started</label>
          <v-select
            v-model="requirement.negative"
            :items="[{ text: 'after', value: true }, { text: 'on or before', value: false }]"
          />
          <label class="body px-2"></label>
          <date-picker
            v-model="requirement.value"
            append-icon="mdi-menu-down"
          />

          <v-spacer />

          <!-- Cancel Button -->
          <v-tooltip left color="grey darken-3">
            <v-btn small flat fab
              slot="activator"
              key="cancel"
              @click="cancel"
              color="grey"
            >
              <v-icon>mdi-cancel</v-icon>
            </v-btn>
            <span>Cancel</span>
          </v-tooltip>
          <!-- Delete Button -->
          <v-tooltip left v-if="requirement.id" color="grey darken-3">
            <v-btn small flat error fab
              slot="activator"
              @click="destroy"
              key="delete"
              color="error"
            >
              <v-icon>mdi-delete</v-icon>
            </v-btn>
            <span>Delete</span>
          </v-tooltip>
          <!-- Submit Button -->
          <v-tooltip left color="grey darken-3">
            <v-btn small fab
              slot="activator"
              @click="submit"
              key="save"
              color="primary"
            >
              <v-icon>mdi-content-save</v-icon>
            </v-btn>
            <span v-if="requirement.id">Update</span>
            <span v-else>Create</span>
          </v-tooltip>
        </v-toolbar>
      </td>
    </can>
  </tr>
  <tr v-else class="requirement row qualification-commencement viewing" key="viewing">
    <th v-if="first" class="text-xs-right">Qualification</th>
    <td v-else class="text-xs-right">
      {{ requirement.mandatory ? 'and' : 'or' }}
    </td>
    <td>
      {{ requirement.mandatory ? 'must' : 'could' }}
      be started
      {{ requirement.negative ? 'after' : 'on or before' }}
      <em>{{ new Date(requirement.value) | date('do MMMM yyyy') }}</em>
    </td>
    <td class="text-xs-right">
      <can I="edit" a="Opportunity">
        <v-btn small flat @click.prevent="edit" color="primary">
          Edit
        </v-btn>
      </can>
    </td>
  </tr>
</template>

<script>
  // Vue Component
  export default {
    props: {
      requirement: { type: Object, required: true },
      first:       { type: Boolean }
    },
    computed: {
      creating() { return this.requirement.id == null }
    },
    methods: {
      edit() { this.requirement.editing = true },
      cancel() {
        this.$store.dispatch('opportunities/fetch', this.$route.params.id)
        this.requirement.editing = false
        },
      destroy() {
        if (this.requirement.id) {
          this.$store.dispatch('requirements/destroy', this.requirement)
        } else {
          this.$store.dispatch('opportunities/fetch', this.$route.params.id)
        }
      },
      submit() {
        if (this.requirement.id) {
          this.$store.dispatch('requirements/update', this.requirement).then(
            (feedback) => {
              if (feedback) {
                this.$store.commit('snackbar', { text: 'There was a problem updating the requirement', type: 'error' })
                this.requirement = feedback
              } else {
                this.$store.commit('snackbar', { text: 'Requirement was updated successfully', type: 'success' })
              }
            }
          )
        } else {
          this.$store.dispatch('requirements/create', this.requirement).then(
            (feedback) => {
              if (feedback) {
                this.$store.commit('snackbar', { text: 'There was a problem creating the requirement', type: 'error' })
                this.requirement = feedback
              } else {
                this.$store.commit('snackbar', { text: 'Requirement was created successfully', type: 'success' })
              }
            }
          )
        }
      }
    }
  }
</script>
